import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { useAuth } from "../context/AuthContext";


export default function OwnerLoginPage() {
  const {
    user,
    loading: authLoading,
    loginWithPassword,
    logout,
  } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!authLoading && user?.role === "owner") {
      navigate("/owner/lilly", { replace: true });
    }
  }, [authLoading, navigate, user]);

  if (!authLoading && user?.role === "owner") {
    return <Navigate to="/owner/lilly" replace />;
  }

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const authenticated = await loginWithPassword(email, password);
      if (authenticated?.role !== "owner") {
        await logout();
        setError("This private area requires the configured owner account.");
        return;
      }
      navigate("/owner/lilly", { replace: true });
    } catch {
      setError("Owner login was not accepted.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-[75vh] px-6 py-20">
      <section className="mx-auto max-w-md border border-[var(--gu-border)] bg-[var(--gu-surface)] p-8">
        <p className="overline text-[var(--gu-muted)]">Private local staging</p>
        <h1 className="mt-3 font-display text-4xl">Katie’s owner login</h1>
        <p className="mt-4 text-sm leading-6 text-[var(--gu-muted)]">
          This area is restricted to the configured Grace owner account.
        </p>

        <form className="mt-8 space-y-5" onSubmit={submit}>
          <label className="block">
            <span className="overline text-[var(--gu-muted)]">Email</span>
            <input
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="mt-2 w-full border border-[var(--gu-border)] bg-[var(--gu-bg)] px-4 py-3 outline-none focus:ring-2 focus:ring-[var(--gu-accent)]"
            />
          </label>
          <label className="block">
            <span className="overline text-[var(--gu-muted)]">Password</span>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="mt-2 w-full border border-[var(--gu-border)] bg-[var(--gu-bg)] px-4 py-3 outline-none focus:ring-2 focus:ring-[var(--gu-accent)]"
            />
          </label>
          {error && (
            <p role="alert" className="text-sm text-red-700">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[var(--gu-primary)] px-5 py-3 text-[var(--gu-bg)] disabled:opacity-60"
          >
            {submitting ? "Checking…" : "Enter private test environment"}
          </button>
        </form>
      </section>
    </main>
  );
}
